import React, { useEffect, useRef, useState } from 'react'
import AdvertisementLinkWrapper from './AdvertisementLinkWrapper'
import AdvertisementImages from './AdvertisementImages'
import withIsInViewport from '../hooks/withIsInViewport'
import { trackAdvertisementView } from '../tracking'
import getCookie from '../functions/getCookie'

const writeCookie = () => {
    const now = new Date();
    const minutes = 30;
    now.setTime(now.getTime() + (minutes * 60 * 1000));
    
    const expiry = "expires=" + now.toUTCString() + ";"
    const cookieExists = getCookie('fireplace')
    let stateCheck = (document.readyState === 'loading' || document.readyState === 'interactive') && !cookieExists ? setInterval(() => {
        if (document.readyState === 'complete') {
          clearInterval(stateCheck);
          
          if(!cookieExists) {
              document.cookie = 'fireplace=fireplace-in-view;'+expiry+'; path=/';
          }
        }
    }, 100) : '';

}

const AdvertisementItem = ({item, imageURLs, itemOrigin, isInViewport, refElemViewport, imgTag = false, children = false, initValue = 'init'}) => {
    const [wasInViewport, setIsInViewport] = useState(false)

    useEffect(() => {
        if(!wasInViewport && isInViewport)  {
            setIsInViewport(true)
        }
    }, [isInViewport])

    useEffect(() => {
        if(wasInViewport)  {
            trackAdvertisementView(itemOrigin, item.pk, item.title)
        }

        if(itemOrigin === 'Fireplace') {
            if(window.BorlabsCookie) {
                writeCookie()
            }
            //Die Events borlabs-cookie-handle-unblock und borlabs-cookie-consent-saved existieren auch in 3.0. Kann nach update von allen Seiten dann aufgeräumt werden.
            window.addEventListener('borlabs-cookie-consent-saved', writeCookie)
            window.addEventListener('borlabs-cookie-code-unblocked', writeCookie)
            window.addEventListener('borlabs-cookie-handle-unblock', writeCookie)
        
            return () => {
                window.removeEventListener('borlabs-cookie-consent-saved', writeCookie)
                window.removeEventListener('borlabs-cookie-code-unblocked', writeCookie)
                window.removeEventListener('borlabs-cookie-handle-unblock', writeCookie)
            }
        }

    }, [wasInViewport])

    return (
        <AdvertisementLinkWrapper
            refElemViewport={refElemViewport}
            item={item}
            eventOrigin={itemOrigin}
        >
            {children ? (
                children
            ): (
                <AdvertisementImages
                    images={item.images} 
                    imageURLs={imageURLs}
                    imgTag={imgTag}
                />
            )}

        </AdvertisementLinkWrapper>
    )
}

export default withIsInViewport(AdvertisementItem)